export default "__VITE_ASSET__n5lEi7kB__"